function showSubmitModal( postID, changeURL = true ) {
	jQuery.ajax({
		url: window.ys.find_your_adventure.apiUrl + `/detail/${postID}`,
		type: 'GET',
		dataType: 'json',
		success: function(response) {
			const submit_modal = jQuery( '.fya-submit-item' );
			const itemURL = `${fyaurl}#fyapic${postID}`;
			const itemMainPageURL = `${fyaUrlMainpage}#fyapic${postID}`;

			const socialURLs = {
				facebook: `https://www.facebook.com/dialog/share?app_id=${ys.find_your_adventure.facebookAppId}&message=${encodeURIComponent( response.data.title )}&href=${encodeURIComponent( itemMainPageURL )}`,
				x: `https://twitter.com/intent/tweet?url=${encodeURIComponent( itemMainPageURL )}&text=${encodeURIComponent( response.data.title )}`
			};

			submit_modal.find( '.js-fya-image' ).attr( 'src', response.data.image );
			submit_modal.find( '.js-fya-caption' ).text( response.data.title );
			submit_modal.find( '.js-fya-username' ).text( response.data.name );
			submit_modal.find( '.js-fya-submit-item-url' ).val( itemURL );
			submit_modal.find( '.js-fya-facebook-url' ).attr( 'href', socialURLs.facebook );
			submit_modal.find( '.js-fya-x-url' ).attr( 'href', socialURLs.x );
			submit_modal.find( '.js-fya-vote-item-votes' ).text( response.data.votes );

			submit_modal.find( '.js-fya-vote-item-button' )
				.attr('data-id', postID)
				.attr('data-round', response.data.round)
				.attr('data-votes', response.data.votes);

			window.FindYourAdventure.Voter.RegisterVoteButtonClickListeners();

			submit_modal.addClass( 'active' );

			if( changeURL ) {
				history.pushState( null, '', itemURL );
			}

			console.log( 'vše jede' );
		},
		error: function(response) {
			alert(window.ys.find_your_adventure.error_messages.failed_to_load_adventure_details);
		}
	});
}

function closeSubmitModal() {
	const submit_modal = jQuery( '.fya-submit-item' );

	submit_modal.removeClass( 'active' );

	submit_modal.find( '.js-fya-image' ).text( '' );
	submit_modal.find( '.js-fya-caption' ).text( '' );
	submit_modal.find( '.js-fya-username' ).text( '' );
	submit_modal.find( '.js-fya-facebook-url' ).attr( 'href', '' );
	submit_modal.find( '.js-fya-x-url' ).attr( 'href', '' );
	submit_modal.find('.js-fya-vote-item-votes').text( '0' );

	// Only remove the hash if it matches #fyapic{number}
	if ( /^#fyapic\d+$/.test( window.location.hash ) ) {
		const newURL = window.location.href.replace( window.location.hash, '' );
		history.pushState(null, '', newURL );
	}
}

function checkForSubmitInUrl() {
	// Check if the URL contains a hash
	var hash = window.location.hash;

	// Regex to match '#fyapic' followed by a number
	var match = hash.match(/^#fyapic(\d+)$/);

	if (match) {
		var postID = parseInt( match[1], 10 );
		showSubmitModal( postID, false );
	}
}

function copyFromInput( $input ) {
	const textToCopy = $input.val();

	// Create a temporary textarea to copy text from
	const $temp = jQuery('<textarea>');
	jQuery('body').append($temp);
	$temp.val(textToCopy).select();
	document.execCommand('copy');
	$temp.remove();
}

function uploadFloatingButton() {
	const targets = document.querySelectorAll('main .find-your-adventure [href="#upload-pic"]');
	const targetToToggle = document.querySelector('.upload-floating');

	if (!targets.length || !targetToToggle) {
		return;
	}

	if( contestIsOver ) {
		jQuery( '.fya-button.upload-floating' ).remove();
	}

	let visibleMap = new Map();

	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			visibleMap.set(entry.target, entry.isIntersecting);
		});

		// Check if ANY target is visible
		const anyVisible = Array.from(visibleMap.values()).some(Boolean);

		if (anyVisible) {
			targetToToggle.classList.add('d-none'); // hide button
		} else {
			targetToToggle.classList.remove('d-none'); // show button
		}
	}, { threshold: 0.01 });

	targets.forEach(target => {
		visibleMap.set(target, false); // initialize as not visible
		observer.observe(target);
	});
}

function navRounds() {
	jQuery('.fya-rounds__nav a').on('click', function (event) {
		event.preventDefault();
		event.stopPropagation();

		const $link = jQuery(this);
		const targetId = $link.attr('href'); // e.g., #round-2

		// 1. Update nav active state
		$link.closest('li').addClass('active').siblings().removeClass('active');

		jQuery('.fya-rounds__sliders').children(":not(.fya-rounds__sliders-bg)").addClass('d-none');

		// 2. Show correct slider in .fya-rounds__sliders
		const $targetSlider = jQuery('.fya-rounds__sliders .fya-rounds__slider' + targetId);
		
		if ($targetSlider.length) {
			$targetSlider.removeClass('d-none');
		}
	});

	/*
	const now = new Date();

    const $rounds = jQuery( '.fya-rounds__nav li ');
    let clicked = false;

    $rounds.each(function (index) {
        const $li = jQuery(this);
        const startStr = $li.data('round-start');
        const endStr = $li.data('round-end');

        const startDate = new Date(startStr);
        const endDate = new Date(endStr);

        if (now >= startDate && now <= endDate) {
            $li.find('a')[0].click();
            clicked = true;
            return false; // break loop
        }
    });

    if (!clicked) {
        const first = $rounds.first();
        const last = $rounds.last();
        const firstStart = new Date(first.data('round-start'));
        const lastEnd = new Date(last.data('round-end'));

        if (now < firstStart) {
            first.find('a')[0].click();
        } else if (now > lastEnd) {
            last.find('a')[0].click();
        }
    }
				*/
}

function fyaToast(msg) {
	var t = $('<div class="toast">').text(msg);
	$('body').append(t);
	setTimeout(function(){ t.addClass('show'); }, 10);
	setTimeout(function(){ 
		t.removeClass('show');
		setTimeout(function(){ t.remove(); }, 300);
	}, 3000);
}

jQuery( document ).ready(function(){
	if( contestIsOver ) {
		jQuery( 'body' ).addClass( 'fya-contest-is-over' );
	}

	jQuery( document ).on( 'click', '.js-fya-vote-item-button.disabled', function(){
		fyaToast( ys.find_your_adventure.alreadyVoted );
	});

	checkForSubmitInUrl();
	uploadFloatingButton();
	navRounds();

	jQuery('.fya-copy-input-content .fya-button--copy').on('click', function () {
		const $input = jQuery( this ).closest( '.fya-copy-input-content' ).find( '[name="submit-item-url"]' );
		copyFromInput( $input );
	});

	jQuery( '.find-your-adventure__form__button--back' ).on( 'click', function(event){
		event.preventDefault();
		jQuery( '.find-your-adventure__form-popup' ).removeClass( 'active' );
	});

	jQuery( '.find-your-adventure' ).on( 'click', '.js-fya-vote-item-link', function( event ){
		event.preventDefault();

		const postID = parseInt( jQuery( this ).parent().find( '[data-id]' ).attr( 'data-id' ) );
		showSubmitModal( postID );
	});

	jQuery( '.fya-submit-item__close' ).on( 'click', function( event ){
		event.preventDefault();
		closeSubmitModal();
	});

	jQuery( '.find-your-adventure__form__error button' ).on( 'click', function(){
		jQuery( '.find-your-adventure__form__error' ).addClass( 'hidden' );
	});
});

(function () {
	this.FindYourAdventure = function (config) {
		this.FindYourAdventure.Config = {
			debug: config.debug || false,
			apiUrl: config.apiUrl,
			selectors: {
				vote: {
					item: {
						button: '.js-fya-vote-item-button',
						count: '.js-fya-vote-item-votes',
					},
					item_modifiers: {
						liked: 'liked',
						loading: 'loading',
						disabled: 'disabled',
					}
				},
				adventures: {
					listing: {
						base: '.js-fya-adventures-listing',
						buttonLoadMore: '.js-fya-adventures-listing-load-more-button',
					}
				}
			},
		};
	};

	//init
	this.FindYourAdventure(window.ys.find_your_adventure);

	document.addEventListener(
		'DOMContentLoaded',
		function () {
			// Initialize services
			this.FindYourAdventure.Logger = new this.FindYourAdventure.LoggerService(
				this.FindYourAdventure
			);

			this.FindYourAdventure.UserData = new this.FindYourAdventure.UserDataService(
				this.FindYourAdventure
			);
			
			this.FindYourAdventure.UserData.CleanupVotes();

			this.FindYourAdventure.Voter = new this.FindYourAdventure.VoterService(
				this.FindYourAdventure
			);
			
			this.FindYourAdventure.Voter.RegisterVoteButtonClickListeners();

			this.FindYourAdventure.Adventures = new this.FindYourAdventure.AdventuresService(
				this.FindYourAdventure
			);
			
			this.FindYourAdventure.Adventures.RegisterLoadMoreClickListeners();

			this.FindYourAdventure.Adventures.LoadVotesListing();
		}.bind(this)
	);
}).bind(window)();

(function ($) {
	// Owl Carousel for prize sliders
	jQuery('document').ready(function () {
		if (!$.fn.owlCarousel) {
			return;
		}

		var $owlEventNavigation = jQuery('.fya-rounds__slider ul');

		var responsive = {
			0: {
				items: 1,
				margin: 0,
				slideBy: 1,
				mouseDrag: true,
				touchDrag: true,
			}
		};

		var OwlSettings = {
			dots: true,
			nav: true,
			loop: true,
			responsive: responsive,
			//stagePadding: 97.5,
			lazyLoad: true,
			autoWidth: false,
			navText: [
				'<svg width="100%" height="100%" viewBox="0 0 112 144" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-miterlimit:10;"><g transform="matrix(1,0,0,1,-1028.59,-2804.77)"><path id="Shape-1-copy" serif:id="Shape 1 copy" d="M1100.06,2844.97L1068.79,2876.49L1100.06,2908" style="fill:none;stroke:white;stroke-width:8px;"/></g></svg>',
				'<svg width="100%"  height="100%" viewBox="0 0 113 144" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-miterlimit:10;"><g transform="matrix(1,0,0,1,-2969.76,-2804.47)"><path id="Shape-1" serif:id="Shape 1" d="M3009.96,2844.67L3041.61,2876.31L3009.96,2907.96" style="fill:none;stroke:white;stroke-width:8px;"/></g></svg>',
			],
		};

		$owlEventNavigation.each(function () {
			var $_this = jQuery(this);
			$_this.owlCarousel(OwlSettings);
		});
	});
	
	// Owl Carousel for prize sliders
	jQuery('document').ready(function () {
		if (!$.fn.owlCarousel) {
			return;
		}

		var $owlEventNavigation2 = jQuery( '.fya-gof-slider ul' );

		var responsive = {
			0: {
				items: 1,
			},
			768: {
				items: 2,
			},
			1024: {
				items: 3,
			}
		};

		var OwlSettings2 = {
			dots: false,
			nav: true,
			loop: true,
			margin: 30,
			slideBy: 1,
			mouseDrag: true,
			touchDrag: true,
			responsive: responsive,
			lazyLoad: true,
			autoWidth: false,
			navText: [
				`<img src="${ys.find_your_adventure.owlGofNavImage}">`,
				`<img src="${ys.find_your_adventure.owlGofNavImage}" style="transform:rotate(180deg);">`,
			],
		};

		$owlEventNavigation2.each(function () {
			var $_this2 = jQuery(this);
			$_this2.owlCarousel(OwlSettings2);

			// FIX: Access FindYourAdventure from the window object
			if ( window.FindYourAdventure.Voter) {
				window.FindYourAdventure.Voter.RegisterVoteButtonClickListeners();
			}
		});
	});
})(jQuery);